import { createSlice } from "@reduxjs/toolkit";

const safeParse = (key, fallback) => {
    try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : fallback;
    } catch (error) {
        // 如果历史数据不可解析则清理，避免阻塞页面
        localStorage.removeItem(key);
        return fallback;
    }
};

const mainSlice = createSlice({
    name: "main",
    initialState: () => {
        // 从 localStorage 读取数据，如果没有则返回默认值
        const mainTags = safeParse('jtg-caiwu_mainTag', [{ key:'/DeskHome', label:'首页' }]);
        const mainTagActive = safeParse('jtg-caiwu_mainTagActive', '/DeskHome');
        
        return {
            mainTags,
            mainTagActive,          
        };
    },
    reducers: {
        setMain(state, action) {
            const safeTags = (action.payload.mainTags || []).map(tag => ({
                ...tag,
                // avoid storing React elements to keep state serializable
                label: typeof tag.label === 'string' ? tag.label : (tag.key || '')
            }));

            state.mainTags = safeTags;
            state.mainTagActive = action.payload.mainTagActive;
            
            // 存储到 localStorage
            localStorage.setItem('jtg-caiwu_mainTag', JSON.stringify(state.mainTags));
            localStorage.setItem('jtg-caiwu_mainTagActive', JSON.stringify(state.mainTagActive));
        },
        // 新增：重置 mainSlice 的 reducer
        resetMain(state) {
            // 重置为初始值
            state.mainTags = [{ key:'/DeskHome', label:'首页' }];
            state.mainTagActive = '/DeskHome';
            
            // 清理 localStorage
            localStorage.removeItem('jtg-caiwu_mainTag');
            localStorage.removeItem('jtg-caiwu_mainTagActive');
        }
    }
});

export const { setMain, resetMain } = mainSlice.actions;  // 导出新增的 resetMain
export const { reducer: mainReducer } = mainSlice;